var _g, _rect, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCarbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 48,
    viewBox: "0 0 84 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41025_42503)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#pattern0_41025_42503)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 46.5,
    height: 46.5,
    rx: 23.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_41025_42503)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#pattern1_41025_42503)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 48,
    height: 48,
    rx: 24,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.875 16.5L60.375 9L72.875 16.5L60.375 24L47.875 16.5Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.875 31.5L60.3749 39V24L47.875 16.5V31.5Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.875 32L60.375 39V24L72.875 16.5V32Z",
    fill: "#5C5C5C"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.75,
    y: 0.75,
    width: 46.5,
    height: 46.5,
    rx: 23.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_41025_42503",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_41025_42503",
    transform: "scale(0.00520833)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_41025_42503",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_41025_42503",
    transform: "scale(0.00520833)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41025_42503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_41025_42503"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_41025_42503",
    width: 192,
    height: 192,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCarbon);
export default __webpack_public_path__ + "static/media/logo-carbon.b02f72a4b61e67aff567337d6919ab8e.svg";
export { ForwardRef as ReactComponent };